import type { Portfolio } from '../../api/portfolio-client/portfolio-client.type';
import { useGlobalStore } from './global-store';

/**
 * Hook to get the current organization ID from the global store
 *
 * @returns {string | null} The organization ID if available, null otherwise
 */
const useOrgId = (): string | null => {
  const organization = useGlobalStore((state) => state.organization);

  return organization?.id ?? null;
};

/**
 * Hook to get all portfolios belonging to the current organization from the global store
 *
 * @returns {Portfolio[]} Array of portfolios filtered by the current organization ID
 */
const useOrgPortfolios = (): Portfolio[] => {
  const organization = useGlobalStore((state) => state.organization);
  const portfolios = useGlobalStore((state) => state.portfolios);

  if (!organization?.id) {
    return [];
  }

  return portfolios.filter((portfolio) => portfolio.organization.id === organization.id);
};

export { useOrgId, useOrgPortfolios };
